const en_sales_so = {
    "": "sales order",
    add: "create sales order",
    detail: "sales order detail",
    do: "sales order (DO OUT)",
    edit: "edit sales order",
    po: "incoming purchase order",
    po_detail: "incoming purchase order detail",

    label: {
        btn_po: "incoming PO - partner",
        btn_createDO: "create goods issue",
        btn_reset_goods: "reset goods",
        no_so_ref: "SO number / reference number",
    },

    message: {
        delete_title: "Are you sure you want to delete this SO?",
        delete_text: "Enter the reason for cancelling the SO.",
        reject_title: "Are you sure you want to cancel the SO?",
        reject_text: "Enter the reason for cancelling the SO.",
    },

    error: {
        create: "Failed to create SO.",
        create_do: "Failed to create goods issue reference (DO OUT).",
        delete: "Failed to cancel SO.",
        edit: "Failed to update SO.",

        reject: "Failed to cancel SO.",
        approve: "Failed to confirm SO.",
        done: "Failed to complete SO.",
    },

    success: {
        create: "SO created successfully.",
        create_do: "Goods issue reference (DO OUT) created successfully.",
        delete: "SO cancelled successfully.",
        edit: "SO updated successfully.",

        reject: "SO cancelled successfully.",
        approve: "SO confirmed successfully.",
        done: "SO completed successfully.",
    },
}

export default en_sales_so;